import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapVue from 'bootstrap-vue'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faCheck
} from '@fortawesome/free-solid-svg-icons'

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import VueScrollTo from 'vue-scrollto'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCarousel from 'vue-carousel';

library.add(
  faCheck
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(BootstrapVue)
Vue.use(VueI18n)
Vue.use(VueScrollTo)
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueCarousel);

const messages = {
  'en': require('@/locales/en.json'),
  'fi': require('@/locales/fi.json'),
  'fr': require('@/locales/fr.json')
}

const i18n = new VueI18n({
  locale: navigator.language.split('-')[0], // set locale,
  fallbackLocale: 'en',
  messages // set locale messages
})


new Vue({
  i18n,
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
